document.documentElement.classList.add('js');

function updateProductVariant(form) {
  const master = form.querySelector('[data-variant-select]');
  if (!master) return;
  const selectedOptions = Array.from(form.querySelectorAll('[data-option-select]')).map((select) => select.value);
  const matchingOption = Array.from(master.options).find((option) => {
    try { return JSON.parse(option.dataset.options || '[]').every((value, index) => value === selectedOptions[index]); }
    catch (_) { return false; }
  });
  if (!matchingOption) return;
  master.value = matchingOption.value;
  const button = form.querySelector('[data-add-to-cart]');
  const price = form.closest('.product-info')?.querySelector('.product-price');
  if (price && matchingOption.dataset.price) price.textContent = matchingOption.dataset.price;
  if (button) {
    const available = matchingOption.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
  }
}

document.addEventListener('change', (event) => {
  const optionSelect = event.target.closest('[data-option-select]');
  if (optionSelect) updateProductVariant(optionSelect.closest('form'));
});

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-menu-toggle]');
  if (!trigger) return;
  const panel = document.getElementById(trigger.getAttribute('aria-controls'));
  const open = trigger.getAttribute('aria-expanded') === 'true';
  trigger.setAttribute('aria-expanded', String(!open));
  trigger.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
  if (panel) panel.hidden = open;
  document.body.classList.toggle('menu-open', !open);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const trigger = document.querySelector('[data-menu-toggle][aria-expanded="true"]');
  if (!trigger) return;
  const panel = document.getElementById(trigger.getAttribute('aria-controls'));
  trigger.setAttribute('aria-expanded', 'false');
  trigger.setAttribute('aria-label', 'Open menu');
  if (panel) panel.hidden = true;
  document.body.classList.remove('menu-open');
  trigger.focus();
});

document.addEventListener('toggle', (event) => {
  const current = event.target;
  if (!current.matches('.mobile-nav > details') || !current.open) return;
  current.parentElement.querySelectorAll(':scope > details[open]').forEach((item) => {
    if (item !== current) item.open = false;
  });
}, true);

window.addEventListener('resize', () => {
  if (window.innerWidth <= 900) return;
  const trigger = document.querySelector('[data-menu-toggle][aria-expanded="true"]');
  if (!trigger) return;
  const panel = document.getElementById(trigger.getAttribute('aria-controls'));
  trigger.setAttribute('aria-expanded', 'false');
  trigger.setAttribute('aria-label', 'Open menu');
  if (panel) panel.hidden = true;
  document.body.classList.remove('menu-open');
});
